export default {
    'name': 'substances',
    'label': 'CAS.Substances',
    'getComponent': () => import('./Substances.vue'),
    'tabIndex': 100,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/cas/substances',
};
